import { z } from 'zod';

export const activityFormSchema = z.object({
  title: z.string().min(1, { message: 'Title is required' }),
  icon: z.string().min(1, { message: 'Icon is required' }),
  feePercentage: z.coerce
    .number()
    .min()
    .max(100, { message: 'Fee percentage must be less than 100' }),
  isWaiverRequired: z.boolean(),
  isFirstAidRequired: z.boolean(),
  isQualificationRequired: z.boolean(),
  isLocationRequired: z.boolean(),
  servicesContractStr: z.string().min(1),
  activityQualifications: z.array(
    z.object({
      name: z.string().min(1),
      description: z.string().min(1)
    })
  ),
  isEnabled: z.boolean()
});
